import {Type} from 'class-transformer';
import {Stringifier} from "../services/stringifier.service";

@Stringifier
export class User {
  userId: number = 0;
  username: string = '';
  password: string = '';
  active: boolean = false;
  isSuperUser: boolean = false;

  name: string = '';
  surname: string = '';
  mail: string = '';

  languageCode: string = 'it-IT';
  // role: UserType = UserType.Unknown;

  @Type(() => Date)
  createdAt: Date = new Date();

    static getStringifier(level: number): User | null {
        if (level < 0) {
            return null;
        }
        // @ts-ignore
        return {
            userId: null,
            username: null,
            password: null,
            active: null,
            isSuperUser: null,
            name: null,
            surname: null,
            mail: null,
            languageCode: null,
            createdAt: null,
        } as User;
    }
}
